import React, { useState, useEffect } from "react";
import './Login.css';
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Outlet, Link, Await } from "react-router-dom";
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import Container from 'react-bootstrap/Container';
import Logoimg from '../../assets/img/logo.png';
import downloadd from '../../assets/img/download.png';
import { NumberOutlined, UserOutlined, LockOutlined, PhoneOutlined } from '@ant-design/icons';
import { Col, Row, Form, Input } from 'antd';
import { Spinner } from "react-bootstrap";
import { ArrowRight, EyeSlash, EyeFill } from "react-bootstrap-icons";
import kgfvideo from '../../assets/img/kgfvideo.mp4';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ReactPWAInstallProvider, { useReactPWAInstall } from "react-pwa-install";
import Cookies from 'js-cookie';
import { v4 as uuidv4 } from 'uuid';
import PWAPrompt from 'react-ios-pwa-prompt'
import Prompt from 'react-ios-pwa-prompt';
import { FaWhatsappSquare } from "react-icons/fa";

// import {useNavigate} from 'react-router-dom';

import Whatsapp from '../../assets/img/whatsappicon.png'


function Login() {
    const [browserId, setBrowserId] = useState('');
    const [appmanagerdata, setAppmanager] = useState(null);
    const [helplinenumber, setMinibet] = useState([]);
    const [Maxpoints, setMaxpoints] = useState([]);
    const [loading, setLoading] = useState(false);
    const mobile1 = window.innerWidth <= 768 ? true : false;

    const navigate = useNavigate();

    localStorage.setItem('helplinenumber', JSON.stringify(helplinenumber));



    useEffect(() => {

        let browserIdd = Cookies.get('browserId');

        if (!browserIdd) {
            browserIdd = uuidv4();
            Cookies.set('browserId', browserIdd, { expires: 7 }); // Store the ID in a cookie that expires in 365 days
        }
        setBrowserId(browserIdd)
        // alert(browserIdd);


        // console.log('Browser ID:', browserIdd);
    }, [mobile1]);





    const [deferredPrompt, setDeferredPrompt] = useState(null);
    const [showInstallButton, setShowInstallButton] = useState(true);

    var token = localStorage.getItem("userid");

    // useEffect(() => {
    //   if (token) {
    //     window.location.href = '/Home';
    //   }
    // }, [])

    useEffect(() => {
        const userid = localStorage.getItem("userid");
        if (userid) {
            navigate('/');
        }
        window.addEventListener('beforeinstallprompt', (event) => {
            event.preventDefault();
            setDeferredPrompt(event);
        });

        return () => {
            window.removeEventListener('beforeinstallprompt', (event) => {
                event.preventDefault();
                setDeferredPrompt(event);
            });
        };
    }, []);

    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);



    useEffect(() => {
        // Check if the app has been installed (stored in local storage)
        const isAppInstalled = localStorage.getItem('isAppInstalled');
        if (isAppInstalled) {
            setShowInstallButton(false);
        }
    }, []);

    const handleInstallClick = () => {
        // alert('fff')
        if (deferredPrompt) {
            deferredPrompt.prompt();

            deferredPrompt.userChoice.then((choiceResult) => {
                if (choiceResult.outcome === 'accepted') {
                    console.log('User accepted the A2HS prompt');

                    localStorage.setItem('isAppInstalled', 'true');
                    setShowInstallButton(false);
                } else {
                    console.log('User dismissed the A2HS prompt');
                }

                setDeferredPrompt(null);
            });
        }
    };

    const onFinish = (values) => {
        // console.log('Success:', values);
    };
    const onFinishFailed = (errorInfo) => {
        console.log('Failed:', errorInfo);
    };



    localStorage.setItem("token", "");
    const [user, setUserts] = useState({
        mobile: "",
    });

    const [motp, setMotp] = useState(
        {
            mobile: "9782140792",
            otp: "123456"
        }
    )



    const [mobile, setmobile] = useState("");
    const [password, setPassword] = useState("")

    const onInputChangemobile = (e) => {
        setmobile(e.target.value);
    };

    const onInputChangepassword = (e) => {
        setPassword(e.target.value);
    };

    const Submit = async () => {
        const devid = localStorage.getItem("dev_id");
        const user_id = localStorage.getItem("userid");

        console.log("Submitting login request...");

        try {
            setLoading(true);

            // const url = "https://nodeapi.khelogalifaridabad.com/api/users/login";
            const url = `${process.env.REACT_APP_API_URL}/login`;


            // Prepare JSON data
            const requestData = {
                mobileNum: mobile,
                pss: password,
                dev_id: browserId,
                app_id: "com.Krishnadmatka"
            };

            const config = {
                method: "POST",
                url: url,
                headers: {
                    "Content-Type": "application/json"
                },
                data: JSON.stringify(requestData)
            };

            // Send request
            const response = await axios(config);
            console.log(response)
            if (response.status == 200) {
                if (response.data.success === "1") {
                    console.warn("Login successful");

                    Swal.fire({
                        icon: "success",
                        title: "Login successfully!",
                        text: response.data.message,
                        timer: 2000
                    }).then(() => {
                        navigate("/");
                        localStorage.setItem("userid", response.data.user_id);
                        localStorage.setItem("dev_id", response.data.device_id);
                        localStorage.setItem("login_token", response.data.login_token);
                    });

                } else if (response.data.success === "3") {
                    Swal.fire({
                        icon: "error",
                        title: "Account Blocked",
                        text: response.data.message,
                        timer: 2000
                    });
                } else {
                    Swal.fire({
                        icon: "error",
                        title: "Login Failed",
                        text: response.data.message || "An unknown error occurred.",
                        timer: 2000
                    });
                }
            } else {
                Swal.fire({
                    icon: "error",
                    title: "Error!",
                    text: "Login Failed!",
                    timer: 2000
                });
            }

        } catch (error) {
            console.error("Login request failed:", error);
            Swal.fire({
                icon: "error",
                title: "Error!",
                text: "An unexpected error occurred. Please try again.",
                timer: 2000
            });
        } finally {
            setLoading(false);
        }
    };





    const app_manager = async () => {
        const devid = localStorage.getItem("dev_id");

        try {
            const url = `${process.env.REACT_APP_API_URL}/POM_help_number`;

            // Request payload in JSON format
            const requestData = {
                app_id: process.env.REACT_APP_API_ID,
                // dev_id: devid
            };

            // Sending request as JSON
            const response = await axios.post(url, requestData, {
                headers: {
                    "Content-Type": "application/json"
                }
            });

            const objectRes = response.data.data;
            setAppmanager(objectRes);

            if (objectRes?.help_line_number) {
                setMinibet(objectRes.help_line_number);
                console.warn(objectRes.help_line_number);
            }

            console.warn(objectRes);

        } catch (error) {
            console.error("Error fetching app manager data:", error);
        }
    };

    useEffect(() => {
        app_manager();
    }, [])


    const [showVideo, setShowVideo] = useState(false);

    const handlePlayClick = () => {
        // Show the video in fullscreen when the play button is clicked
        setShowVideo(true);
    };

    const handleVideoClose = () => {
        // Close the fullscreen video
        setShowVideo(false);
    };






    return (
        <>
            <div className="Loginpage">



                <div className="logobgshape d-flex justify-content-center align-items-center ">
                    <div className="logo ">
                        <img src={Logoimg} width="150" />

                    </div>
                </div>


                <div className="loginform">
                    <div className="bg-white login-form">
                        <h3 className="mb-0 fw-bold text-center text-secondary">Welcome Back</h3>
                        {/* <div className="w-100 d-flex justify-content-center align-items-center">

                            <p className="text-center mb-0 pleaselogin me-2 helpline">Helpline Number:</p>
                            <FaWhatsappSquare className="text-success   " />
                            <p className="text-center mb-0 pleaselogin">
                                <a href={`https://wa.me/${helplinenumber}`} target="_blank" rel="noopener noreferrer">
                                    {helplinenumber}
                                </a>
                            </p>
                        </div> */}

                        <div
                            style={{
                                textAlign: "center",
                                marginBottom: "15px",
                            }}
                        >
                            <p
                                className="text-center mb-2 pleaselogin helpline"
                                style={{
                                    color: "#ff4b2b",
                                    fontWeight: "600",
                                }}
                            >
                                Helpline Number:
                            </p>

                            <a
                                href={`https://wa.me/${helplinenumber}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                    display: "inline-flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    gap: "7px",
                                    backgroundColor: "#25D366",
                                    color: "#fff",
                                    padding: "9px 16px",
                                    borderRadius: "6px",
                                    textDecoration: "none",
                                    fontWeight: "600",
                                    fontSize: "15px",
                                    cursor: "pointer",
                                }}
                            >
                                <FaWhatsappSquare
                                    style={{
                                        fontSize: "21px",
                                    }}
                                />

                                <span>{helplinenumber}</span>
                            </a>
                        </div>


                        {/* <div className="d-flex justify-content-center">
                            {!showVideo && (
                                <button
                                    className="btn btn-ronded bg-qwe p-4  justify-content-center"
                                    style={{ marginRight: 7 }}
                                    onClick={handlePlayClick}
                                >
                                    <span className="text-white mb-1 d-block">
                                        डाउनलोड करने के लिए वीडियो देखें
                                    </span>
                                    <span className="text-danger playbtn_custum rounded-circle bg-warning p-2">
                                        <i className="bi bi-play-fill" />
                                    </span>
                                </button>
                            )}
                            {showVideo && (
                                <div className="fullscreen-video-container">
                                    <video controls autoPlay className="fullscreen-video">
                                        <source src={kgfvideo} type="video/mp4" />
                                        Your browser does not support the video tag.
                                    </video>
                                    <button className="close-btn" onClick={handleVideoClose}>
                                        Close
                                    </button>
                                </div>
                            )}
                        </div> */}
                        <Row justify={'center'}>
                            <Col xs={24} xl={8}>
                                <div className="form-login-design">
                                    <Form
                                        name="basic"
                                        labelCol={{
                                            span: 8,
                                        }}
                                        wrapperCol={{
                                            span: 24,
                                        }}
                                        style={{
                                            maxWidth: 600,
                                        }}
                                        initialValues={{
                                            remember: true,
                                        }}
                                        onFinish={onFinish}
                                        onFinishFailed={onFinishFailed}
                                        autoComplete="off"
                                    >
                                        <Row justify={'center'}>
                                            <Col span={24} xl={24} lg={24} md={24} sm={24}>
                                                <Form.Item
                                                    name="username" prefix={<UserOutlined className="site-form-item-icon" />}
                                                    rules={[
                                                        {
                                                            required: true,
                                                            message: 'Please input your Number!',
                                                        },
                                                    ]}
                                                >
                                                    <div className="w-100">
                                                        <Input className="username w-100" name="mobileNum"
                                                            maxLength={10} placeholder="Mobile Number" value={mobile} onChange={onInputChangemobile}
                                                            prefix={<UserOutlined className="site-form-item-icon" style={{ padding: "9px" }} />}
                                                        />
                                                        {/* {isValidMobile ? <p>Valid mobile number!</p> : <p>Invalid mobile number</p>} */}

                                                    </div>
                                                </Form.Item>
                                            </Col>


                                            <Col span={24} xl={24} md={24}>
                                                <Form.Item
                                                    name="password"
                                                    rules={[
                                                        {
                                                            required: true,
                                                            message: 'Please input your Password!',
                                                        },
                                                    ]}
                                                >
                                                    <Input className="username w-100"
                                                        prefix={<LockOutlined className="site-form-item-icon" />}
                                                        type="password" style={{ padding: "9px" }}
                                                        placeholder="Password"
                                                        value={password}
                                                        onChange={onInputChangepassword}
                                                    />
                                                </Form.Item>
                                            </Col>

                                        </Row>
      <Form.Item className="" style={{display:"flex",justifyContent:"end"}}>
                                            <Link className="link btn text-center register1" to="/Forgetpaasword">Forgetpaasword</Link>


                                        </Form.Item>

                                        <Form.Item>
                                            <button disabled={loading} type="button" className="d-block w-100 text-white bg-green refer-button cxy otp_login submit_data btn w-50 p-2 gap-2 d-flex justify-content-center" id="submit_data" name="submit_data" onClick={Submit}>LOGIN
                                                {loading && <Spinner animation="border" />}
                                                <ArrowRight className="fs-3 fw-bold" />
                                            </button>


                                        </Form.Item>
                                  
                                        <Form.Item className="text-center mb-0 mt-2">
                                            <Link className="link btn text-center register1" to="/Register">REGISTER NOW</Link>


                                        </Form.Item>



                                    </Form>



                                    <div className="d-flex justify-content-center mt-4">
                                        {isIOS && (
                                            <>
                                                <p> To add this app to your home screen, tap the share icon below and select "Add to Home Screen."</p>

                                                    // Do something when the user clicks the "Add to Home Screen" button
                                                <button className="btn btn-ronded text-light">Install Web Application Ios</button>

                                            </>

                                        )}
                                        {!isIOS && showInstallButton && (
                                            <button className="btn " onClick={handleInstallClick}>
                                                <img src={downloadd} alt="downloadd" width={120} />
                                            </button>
                                        )}
                                    </div>
                                </div>
                            </Col>
                        </Row>

                    </div>
                </div>
            </div >
            <Prompt />
            <PWAPrompt />
        </>

    );
}

export default Login;


